import { createSelector } from 'reselect';
import { appTimeSelector } from 'shared/app/shell';

import { svcCardsLoadingSelector } from 'shared/app/bundles/svc-cards';
import {
  ADD_PAYMENT,
  defaultOrFirstReloadPaymentInstrumentSelector,
  filterByMOPActionType,
  paymentInstrumentsLoadingSelector,
  validPaymentInstrumentsSelector,
  walletSVCsSelector,
} from 'shared/app/bundles/wallet';
import { selectedStoreMopSvcOnly } from 'shared/app/state/selectors/ordering';

import {
  selectedPaymentSelector,
  selectedReloadSourceIdSelector,
} from 'shared/app/state/selectors/ordering';

import { pricingLoadingSelector, pricingSelector } from './cart';

export const orderPaymentDataLoadingSelector = createSelector(
  svcCardsLoadingSelector,
  paymentInstrumentsLoadingSelector,
  pricingLoadingSelector,
  (svcCardsLoading, paymentMethodLoading, pricingLoading) => {
    return Boolean(svcCardsLoading || paymentMethodLoading || pricingLoading);
  }
);

export const selectedPaymentBalanceSelector = createSelector(
  selectedPaymentSelector,
  (selectedPayment) => selectedPayment?.balance?.amount ?? 0
);

export const orderTotalSelector = createSelector(
  pricingSelector,
  (pricing) => pricing?.summary?.price ?? 0
);

export const pricingExpiredSelector = createSelector(
  pricingSelector,
  appTimeSelector,
  (pricing, appTime) => appTime > pricing?.expiresAt ?? null
);

export const orderPaymentsSelector = createSelector(
  selectedStoreMopSvcOnly,
  validPaymentInstrumentsSelector,
  walletSVCsSelector,
  (svcOnlyStore, paymentInstruments, SVCs) => {
    if (svcOnlyStore) {
      return filterByMOPActionType(SVCs);
    }

    const addPaymentInstrument = {
      paymentType: ADD_PAYMENT,
      paymentInstrumentId: ADD_PAYMENT,
    };
    const filteredPaymentInstruments = filterByMOPActionType([
      ...SVCs,
      ...paymentInstruments,
    ]);

    return [...filteredPaymentInstruments, addPaymentInstrument];
  }
);

export const selectedOrderPaymentSelector = createSelector(
  orderPaymentsSelector,
  selectedPaymentSelector,
  (payments, selectedPayment) => selectedPayment || payments[0]
);

export const selectedOrderReloadSourceIdSelector = createSelector(
  defaultOrFirstReloadPaymentInstrumentSelector,
  selectedReloadSourceIdSelector,
  (defaultPaymentInstrument, selectedReloadSourceId) =>
    selectedReloadSourceId ||
    defaultPaymentInstrument.paymentInstrumentId ||
    ADD_PAYMENT
);
